import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOutlinedIcon from '@mui/icons-material/NotificationsOutlined';
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined';
import ModeCommentOutlinedIcon from '@mui/icons-material/ModeCommentOutlined';
import { Box, Grid, IconButton, Paper, Typography, useMediaQuery, Drawer, Badge, Avatar, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Image from '../../Assets/assetHelper';
import { AuthContext } from '../../Helpers/Contexts/authContext';
import KenColors from '../../Helpers/Themes/kenColors';
import { ReactChildren } from '../../interfaces/Common';
import { AuthUser } from '../../interfaces/Contexts';
import AppBreadCrumbs from '../BreadCrumbs';
import SideNavTabs from './Tabs';
import { useStyles } from './styles';
import routes from '../../Utils/routes';
import MobileNavTabs from './MobileTabs';
import InAppNotifications from './InAppNotification/index';
import CalendarIcon from '../../Assets/icons_calendar.svg';
import SettingIcon from '../../Assets/icons_settings.svg';
import NotificationIcon from '../../Assets/icons_notification.svg';
import { getBasicProfileSetting } from '../../Utils/apiService';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import TimeTracker from '../../TimeTracker/TimeTracker';
import Configurl from '../../Configurl';
import flamelogo1 from '../../Assets/flame-logo.svg';
import flamelogomobile from '../../Assets/flamelogomobile.svg';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Logo from '../../Assets/logo.png';
import MenuIcon from '@mui/icons-material/Menu';
import { parseJwtExpiryMs } from '../../Utils/jwt';

const AppLayout: React.FunctionComponent<ReactChildren> = ({ children }) => {
  const classes = useStyles();
  const {
    state: { user },
    dispatch,
  } = useContext(AuthContext);
  const [notificationAnchor, setNotificationAnchor] = useState<null | HTMLElement>(null);
  const [openNotification, setOpenNotification] = useState(false);
  const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
  const [activeIconIndex, setActiveIconIndex] = useState<number | null>(null);
  const [profileUrl, setProfileUrl] = useState('');
  const [profileName, setProfileName] = useState('');
  const [notificationCount, setNotificationCount] = useState(0);
  const [sessionExpiredOpen, setSessionExpiredOpen] = useState(false);
  const [activeAccessToken, setActiveAccessToken] = useState<string>('');
  const hasLoggedOutRef = useRef(false);
  const [graduation, setGraduation] = useState('');
  const handleClickIcon = (index: number) => {
    // setActiveIconIndex(index === activeIconIndex ? null : index);
  };

  const handleOpenNotification = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationAnchor(event.currentTarget);
    setOpenNotification((prev) => !prev);
  };

  const handleCloseNotification = () => {
    setNotificationAnchor(null);
    setOpenNotification(false);
  };

  // Callback to update notification count when notifications are marked as read
  const handleNotificationCountUpdate = (newCount: number) => {
    setNotificationCount(Math.max(0, newCount));
  };

  const handleOpenMobileNav = () => {
    setIsMobileNavOpen(true);
  };

  const handleCloseMobileNav = () => {
    setIsMobileNavOpen(false);
  };
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width:1025px)');
  const is1980 = useMediaQuery('(max-width:1280px)');
  const is1710 = useMediaQuery('(min-width:1710px)');

  const userData = user as AuthUser;

  console.log(userData, 'skfjbn');

  const performLogout = useCallback(() => {
    if (hasLoggedOutRef.current) return;
    hasLoggedOutRef.current = true;
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    sessionStorage.clear();
    dispatch({ type: 'LOGOUT' });
    navigate(routes.login, { replace: true });
  }, [dispatch, navigate]);

  const handleTokenExpiryLogout = useCallback(() => {
    setSessionExpiredOpen(true);
  }, []);

  useEffect(() => {
    if (!sessionExpiredOpen) return;
    const timer = setTimeout(() => {
      performLogout();
    }, 2500);
    return () => clearTimeout(timer);
  }, [performLogout, sessionExpiredOpen]);

  useEffect(() => {
    const tokenFromContext = userData?.accessToken?.token || '';
    setActiveAccessToken(tokenFromContext);
  }, [userData?.accessToken?.token]);

  useEffect(() => {
    const handleTokenRefresh = () => {
      try {
        const storedUserRaw = localStorage.getItem('user');
        if (!storedUserRaw) return;
        const storedUser = JSON.parse(storedUserRaw);
        const refreshedToken = storedUser?.accessToken?.token;
        if (refreshedToken && typeof refreshedToken === 'string') {
          setActiveAccessToken(refreshedToken);
        }
      } catch (error) {
        console.error('Unable to sync refreshed access token:', error);
      }
    };

    window.addEventListener('tokenRefreshed', handleTokenRefresh as EventListener);
    window.addEventListener('storage', handleTokenRefresh);

    return () => {
      window.removeEventListener('tokenRefreshed', handleTokenRefresh as EventListener);
      window.removeEventListener('storage', handleTokenRefresh);
    };
  }, []);

  useEffect(() => {
    if (!activeAccessToken) return;

    const expiryMs = parseJwtExpiryMs(activeAccessToken);

    console.log(expiryMs , "sdjkfndjdj");
    
    if (!expiryMs) {
      performLogout();
      return;
    }

    const msUntilExpiry = expiryMs - Date.now();
    if (msUntilExpiry <= 0) {
      handleTokenExpiryLogout();
      return;
    }

    const timer = setTimeout(() => {
      handleTokenExpiryLogout();
    }, msUntilExpiry);

    return () => clearTimeout(timer);
  }, [activeAccessToken, handleTokenExpiryLogout, performLogout]);

  const handleListClick = (path: string, index: number) => {
    // console.log('Navigation path:', path);
    setTimeout(() => {
      navigate(path);

      if (path === '/login') {
        dispatch({ type: 'LOGOUT' });
      }
    }, 50);
  };
  // console.log('userData123', userData);

  useEffect(() => {
    if (userData?.applicantId) {
      getBasicProfileSetting(userData.applicantId)
        .then((res) => {
          console.log('Profile data:', res);
          setProfileUrl(res?.accountDetails?.Profile_Picture_URL__c);
          let yearOfGraduation = res?.alumniDetails?.Year_of_Graduation__c;
          setGraduation(yearOfGraduation);
          setProfileName(`${res?.accountDetails?.FirstName} ${res?.accountDetails?.LastName}`);
        })
        .catch((err) => {
          console.error('Error fetching profile:', err);
        });
    }
  }, [userData?.applicantId]);

  const fetchNotificationCount = async () => {
    try {
      const userid = userData?.applicantId;
      if (userid) {
        // Import the function from apiService
        const { getUnreadNotificationCount } = await import('../../Utils/apiService');
        const count = await getUnreadNotificationCount(userid);
        console.log('Notification count:', count);
        setNotificationCount(Math.max(0, count));
      }
    } catch (error) {
      console.error('Error fetching notification count:', error);
      setNotificationCount(0);
    }
  };

  useEffect(() => {
    fetchNotificationCount();
    const interval = setInterval(fetchNotificationCount, 100000);
    return () => clearInterval(interval);
  }, []);

  // console.log('innerwidth12', window.innerWidth);
  const { pathname, state } = useLocation();
  const navigateHistory = decodeURIComponent(pathname)
    .split('/')
    .filter((items) => {
      return items && items !== '';
    });
  console.log(navigateHistory?.[0], 'paramsparamsparamsparams');

  return (
    <>
      <Dialog open={sessionExpiredOpen} onClose={() => {}} disableEscapeKeyDown>
        <DialogTitle>Session Expired</DialogTitle>
        <DialogContent>
          <Typography>Your session has expired. Redirecting to login...</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={performLogout} variant="contained" color="primary">
            Login Again
          </Button>
        </DialogActions>
      </Dialog>
      {user?.applicantEmail && <TimeTracker userId={user.applicantId} email={user.applicantEmail} name={user.applicantName} />}
      {isMobile ? (
        <Grid container spacing={2} sx={{ height: '100vh' }}>
          <Grid item xs={12} sm={12}>
            <Paper sx={{ mt: 2, ml: 2, mr: 2, p: 1, height: 'auto', boxShadow: 'none !important' }}>
              <Grid item container spacing={1} xs={12} lg={12} alignItems="center">
                <Grid item xs={7} display={'flex'} alignItems="center" gap={1}>
                  {navigateHistory?.[0] !== 'home' ? (
                    <IconButton
                      onClick={() => {
                        if (state?.fromProfile) {
                          navigate(routes.myProfile);
                        } else {
                          navigate(-1);
                        }
                      }}
                      sx={{
                        p: 0.5,
                        '&:hover': {
                          backgroundColor: 'rgba(48, 97, 255, 0.1)',
                        },
                      }}
                    >
                      <ArrowBackIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <div onClick={() => navigate('/home')} style={{ cursor: 'pointer' }}>
                      <img alt="logo" style={{ width: '120px' }} src={flamelogo1} />
                    </div>
                  )}
                  {navigateHistory?.[0] !== 'home' && <AppBreadCrumbs />}
                </Grid>
                <Grid item xs={5} display={'flex'} justifyContent="flex-end" alignItems="center" gap={1}>
                  <IconButton
                    sx={{
                      marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                      backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
                      color: activeIconIndex === 3 ? '#5981FF' : 'black',
                      '&:hover': {
                        backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
                      },
                    }}
                    onClick={(event) => {
                      handleClickIcon(3);
                      handleOpenNotification(event);
                    }}
                  >
                    <Badge badgeContent={notificationCount} color="error">
                      <Box
                        sx={{
                          borderRadius: '50%',
                          backgroundColor: '#FFF5E8',
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          width: 36,
                          height: 36,
                        }}
                      >
                        <img alt="" src={NotificationIcon} />
                      </Box>
                    </Badge>
                  </IconButton>
                  <IconButton
                    onClick={handleOpenMobileNav}
                    sx={{
                      borderRadius: '50%',
                      padding: '4px',
                    }}
                  >
                    <Avatar src={profileUrl ? profileUrl : undefined} sx={{ width: 32, height: 32 }}>
                      {userData?.applicantName ? userData.applicantName.slice(0, 2).toUpperCase() : ''}
                    </Avatar>
                  </IconButton>
                  {/* <InAppNotifications
                    anchorEl={notificationAnchor}
                    handleClosePopover={handleCloseNotification}
                    openpop={openNotification}
                    onNotificationCountUpdate={handleNotificationCountUpdate}
                  /> */}
                </Grid>
                <Drawer
                  anchor="right"
                  open={isMobileNavOpen}
                  onClose={handleCloseMobileNav}
                  PaperProps={{
                    sx: {
                      width: '80%',
                      maxWidth: '320px',
                      paddingTop: '16px',
                      paddingBottom: '16px',
                    },
                  }}
                >
                  <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                    <Box sx={{ px: 3, mb: 3 }} className="d-flex gap-3 align-center">
                      <Box>
                        {profileUrl ? (
                          <img
                            src={profileUrl}
                            alt="profile"
                            style={{
                              width: '64px',
                              height: '64px',
                              borderRadius: '50%',
                            }}
                          />
                        ) : (
                          <AccountCircleOutlinedIcon
                            sx={{
                              width: '64px',
                              height: '64px',
                              borderRadius: '50%',
                              color: 'grey',
                            }}
                          />
                        )}
                      </Box>
                      <Box>
                        <Typography sx={{ mt: 1, fontWeight: '500', fontSize: '16px' }}>{profileName || 'User Name'}</Typography>
                        <Typography sx={{ color: '#666', fontSize: '14px', fontWeight: '400' }}>{userData?.applicantId || 'User ID'}</Typography>
                      </Box>
                    </Box>

                    <Box
                      sx={{
                        borderBottom: '1px solid #EAEFFF',
                        width: '100%',
                        mb: 2,
                      }}
                    />

                    <Box sx={{ flex: 1, overflowY: 'auto', px: 1 }}>
                      <MobileNavTabs handleListClick={handleListClick} name="mobile" handleClose={handleCloseMobileNav} />
                    </Box>
                  </Box>
                </Drawer>
              </Grid>
            </Paper>
            <Box
              sx={{
                overflow: 'auto',
                // height: '100vh',
                width: '100%',
                maxWidth: '100%',
                scrollbarColor: 'white',
                p: navigateHistory?.[0] === 'my Feed' ? 0 : 2,
                scrollbarWidth: 'none',
              }}
            >
              {children}
            </Box>
          </Grid>
        </Grid>
      ) : (
        <Grid container spacing={3} style={{ padding: isMobile ? '4px 4px' : '20px 0px 20px 20px' }} sx={{ width: '100vw', height: '100vh' }}>
          <Grid item xs={2} md={2}>
            <Paper className={classes.nav} sx={{ height: 'calc(100vh - 35px)' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: isMobile ? 'center' : '' }}>
                <div style={{ marginBottom: '10px' }}>
                  <img
                    className={classes.profilImage}
                    src={profileUrl ? profileUrl : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT8oJh_Li1F9MTL485spsUw1L-cjntjj49vaCWWPZdjPoeZFH5lsCGjQlMZKwr1vNZUz6M&usqp=CAU'}
                    alt="profile"
                    style={{
                      width: isMobile ? '40px' : is1980 ? '90px' : '108px',
                      height: isMobile ? '40px' : is1980 ? '90px' : '108px',
                      cursor: 'pointer',
                      borderRadius: '50%',
                      // border: '3px solidrgb(202, 202, 202)',
                    }}
                    onClick={() => navigate(routes.settings)}
                  />
                  <Typography className={classes.profileName}>{userData?.applicantName ? (isMobile ? userData.applicantName.slice(0, 2).toUpperCase() : userData.applicantName) : ''}</Typography>
                  {graduation && <Typography className={classes.profileDesignation}>Class of {graduation}</Typography>}
                </div>
                <div>
                  <SideNavTabs handleListClick={handleListClick} />
                </div>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={10} md={10}>
            <Grid container spacing={2}>
              <Grid item container marginLeft={'-10px'} spacing={2} xs={12} lg={12}>
                <Grid item xs={6} sm={8} md={8} lg={8} marginLeft={'-10px'}>
                  <Paper className={classes.header} sx={{ borderRadius: '9px !important' }}>
                    <AppBreadCrumbs />
                  </Paper>
                </Grid>
                <Grid item xs={6} sm={4} md={4} lg={4}>
                  <Paper className={classes.actions} sx={{ display: 'flex', alignItems: 'center' }}>
                    {/* <IconButton
 sx={{
 marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
 backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
 color: activeIconIndex === 0 ? '#5981FF' : 'black',
 '&:hover': {
 backgroundColor: activeIconIndex === 0 ? '#EAEFFF' : 'transparent',
 },
 }}
 disabled={true}
 onClick={() => {
 handleClickIcon(0);
 navigate(routes.schedule);
 }}
 >
 <img alt='' src={CalendarIcon} />
 </IconButton> */}

                    <IconButton
                      sx={{
                        marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                        backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                        color: activeIconIndex === 1 ? '#5981FF' : 'black',
                        '&:hover': {
                          backgroundColor: activeIconIndex === 1 ? '#EAEFFF' : 'transparent',
                        },
                      }}
                      onClick={() => {
                        handleClickIcon(1);
                        navigate(routes.settings);
                      }}
                    >
                      <img alt="" src={SettingIcon} style={{ height: '24px', width: '24px' }} />
                    </IconButton>
                    <IconButton
                      sx={{
                        marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                        backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                        color: activeIconIndex === 2 ? '#5981FF' : 'black',
                        '&:hover': {
                          backgroundColor: activeIconIndex === 2 ? '#EAEFFF' : 'transparent',
                        },
                      }}
                      onClick={() => {
                        handleClickIcon(2);
                        navigate(routes.chats);
                      }}
                    >
                      <ModeCommentOutlinedIcon style={{ color: '#585a64', fontSize: '24px' }} />
                    </IconButton>
                    <IconButton
                      sx={{
                        marginRight: { xs: '4px', sm: '6px', md: '8px', lg: '10px' },
                        backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
                        color: activeIconIndex === 3 ? '#5981FF' : 'black',
                        '&:hover': {
                          backgroundColor: activeIconIndex === 3 ? '#EAEFFF' : 'transparent',
                        },
                      }}
                      onClick={(event) => {
                        handleClickIcon(3);
                        handleOpenNotification(event);
                      }}
                    >
                      <Badge badgeContent={notificationCount} color="error">
                        <Box
                          sx={{
                            borderRadius: '50%',
                            backgroundColor: '#FFF5E8',
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: 36,
                            height: 36,
                          }}
                        >
                          <img alt="" src={NotificationIcon} style={{ height: '24px', width: '24px' }} />
                        </Box>
                      </Badge>
                    </IconButton>
                    <div onClick={() => navigate('/home')}>
                      <img alt="logo" className={classes.actionLogo} src={flamelogo1} />
                    </div>

                    <InAppNotifications
                      anchorEl={notificationAnchor}
                      handleClosePopover={handleCloseNotification}
                      openpop={openNotification}
                      onNotificationCountUpdate={handleNotificationCountUpdate}
                    />
                    <div style={{ height: '45px', background: '#C6C9D2' }} />
                    {/* <div style={{ textAlign: 'start' }}>
 <Typography className={classes.actionText} style={{ textTransform: "uppercase" }}>{Configurl?.OrganizationName}</Typography>
 <Typography className={classes.actionText}>Alumni Suite</Typography>
 </div> */}
                  </Paper>
                </Grid>
              </Grid>
              <Box
                sx={{
                  overflow: 'auto',
                  // overflow: isMobile ? 'auto' : 'hidden',
                  // height: '100vh',
                  // width: '100vw',
                  // height: `calc(100vh - 75px)`,
                  width: '100%',
                  maxWidth: '100%',
                  scrollbarColor: 'white',
                  paddingTop: '3px',
                  paddingLeft: '12px',
                  paddingRight: '12px',
                  scrollbarWidth: 'none',
                }}
              >
                {children}
              </Box>
            </Grid>
          </Grid>
        </Grid>
      )}

      {/* Mobile InAppNotifications */}
      {isMobile && (
        <InAppNotifications anchorEl={notificationAnchor} handleClosePopover={handleCloseNotification} openpop={openNotification} onNotificationCountUpdate={handleNotificationCountUpdate} />
      )}
    </>
  );
};

export default AppLayout;
